import React, { Component } from "react";
import { withStyles } from '@mui/styles';


import USER_ROLES from '../common/userroles'
import slider1 from "./1.jpg";
import slider2 from "./2.jpg";
import slider3 from "./3.jpg";
import brandLogo from "./brand-logo.svg";
import Logo from "../logo";
import Button from "../button";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Amplify from "aws-amplify";
import { Auth } from "aws-amplify";
import KaktusTopLogo from './kaktus/kaktus_top.png';
import KaktusMobile from './kaktus/kaktus_mobile.png';
import KaktusConcierge from './kaktus/kaktus_concierge.png';
import KaktusDeliver from './kaktus/kaktus_deliver.png';
import KaktusPoweredByGrey from './kaktus/kaktus_powered_by_grey.png';
import IlocalCurbside from './kaktus/ilocal_curbside.png';
import IlocalKiosk from './kaktus/ilocal_kiosk.png';
import IlocalMail from './kaktus/ilocal_mail.png';
import IlocalCounter from './kaktus/ilocal_counter.png';
import IlocalCourier from './kaktus/ilocal_courier.png';
import IlocalBedside from './kaktus/ilocal_bedside.png';
import KaktusBottom from './kaktus/kaktus_bottom.png';
import packageJson from '../../../package.json';

// import { navigate } from "@reach/router";
import mainunit from './background-placement-2x-01.png';
import { format } from "date-fns";
import { FormControl, Grid, Hidden, IconButton, Input, InputAdornment, InputLabel, Paper, Stack } from "@mui/material";
import AccountCircle from "@mui/icons-material/AccountCircleOutlined";
import Lock from "@mui/icons-material/LockOutlined";
import NormalButton from '@mui/material/Button';

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh'
    //padding: 16
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  paperLeft: {
    // paddingTop: '4rem',
    // padding: theme.spacing.unit * 2,
    textAlign: "left",
    color: theme.palette.text.secondary
  },
  paperRight: {
    // paddingTop: '4rem',
    // padding: theme.spacing.unit * 2,
    textAlign: "right",
    color: theme.palette.text.secondary
  },
  poweredByLogo: {
    position: "fixed",
    bottom: 14,
    right: 14,
    height: "2rem",
    width: "10rem",
    "@media only screen and (max-height: 520px)": {
      bottom: 0,
      width: "40%"
    }
  },
  formControl: {
    paddingTop: 5,
    paddingBottom: "1rem"
  },
  ternaryButton: {
    backgroundColor: "#efeded",
    height: '55px',
    width: '45%',
    color: 'black',
    '&:hover': {
      backgroundColor: '#efeded',
      color: 'black'
    }
  },
  buttonBar: {
    paddingTop: "2rem",
    minWidth: 300,
    maxWidth: 300,
    marginRight: "auto",
    marginLeft: "auto",
    paddingBottom: "10px"
  },
  loginArea: {
    minWidth: 300,
    maxWidth: 340,
    marginLeft: "auto",
    marginRight: "auto"
  },
  sliderDiv: {
    display: "table-cell",
    marginLeft: "auto",
    position: "relative",
    height: "264px"
  },
  sliderDivContainer: {
    height: "calc(100% - 147px)"
  },
  leftAdArea: {
    minWidth: 300,
    maxWidth: 340,
    display: "table-cell",
    marginLeft: "auto",
    position: "relative",
    background: "linear-gradient(135deg, #50A684 30%, #115E67 90%)"
  },
  chartIcon: {
    verticalAlign: "middle",
    position: "absolute",
    top: 0,
    bottom: 0,
    margin: "auto",
    width: "130px !important",
    left: 0,
    right: 0,
    background: "#fafafa"
  },
  leftAdAreaText: {
    color: "#fafafa",
    fontSize: "larger",
    marginTop: "65px"
  },
  mainContentArea: {
    marginRight: "auto",
    marginLeft: "auto",
    maxWidth: "95%",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "50vh"
  },
  loginContent: {
    marginRight: "auto",
    marginLeft: "auto",
    minWidth: 300,
    maxWidth: 340,
    textAlign: "center",
    paddingBottom: "1rem"
  },
  instruction: {
    paddingBottom: 5,
    paddingLeft: '1%',
    paddingRight: '1%'
  },
  logoContainer: {
    paddingTop: '10%',
    paddingBottom: '10%',
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  footer: {
    textAlign: "center",
    alignItems: "center",
    position: 'fixed',
    width: '50%',
    zIndex: '9999',
    bottom: 15,
    fontSize: '0.9rem',
    fontWeight: '100'
  },
  rightmaincontent: {
    height: '100%',
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    backgroundColor: '#EFF7FA',
    padding: '15px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  rightTitle: {
    fontSize: '80px',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    padding: '30px'
  },
  rightsubtext: {
    fontSize: '35px',
    color: 'rgb(255,255,255)',
    paddingLeft: '135px'
  },
  rightcontent: {
    height: "65%",
    textAlign: 'center',
    backgroundImage: `url(${mainunit})`,
    backgroundSize: '100% 100%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgb(252,108,63)',
    marginTop: '-35px'
  },
  rightimg: {
    width: '100%',
    height: '630px'
  },
  brandLogoSize2: {
    objectFit: "contain",
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    paddingTop: 12,

    /* Extra small devices (phones, 600px and down) */
    "@media only screen and (max-width: 600px)": {
      width: "40%"
    },

    /* Small devices (portrait tablets and large phones, 600px and up) */
    "@media only screen and (min-width: 600px)": {
      width: "70%"
    },

    /* Medium devices (landscape tablets, 768px and up) */
    "@media only screen and (min-width: 768px)": {
      width: "50%"
    },

    /* Large devices (laptops/desktops, 992px and up) */
    "@media only screen and (min-width: 992px)": {
      width: "40%"
    },

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    "@media only screen and (min-width: 1200px)": {
      width: "30%"
    },

    "@media only screen and (max-height: 520px)": {
      width: "15%"
    }
  },
  kaktusLogo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  kaktusBottom: {
    textAlign: "center",
    alignItems: "center",
    position: 'fixed',
    zIndex: '9999',
    bottom: '-15px',
    fontSize: '0.9rem',
    fontWeight: '100',
    width: '50%'
  },
  LearnHowTo: {
    fontFamily: 'auto',
    fontSize: '26px',
    color: '#6C7B92',
    textAlign: 'center',
    fontWeight: 600
  },
  hithLightedFont: {
    fontFamily: 'auto',
    fontSize: '26px',
    color: '#00A7E0',
    fontWeight: 600
  },
  sectionContainer: {
    width: '80%'
  },
  kaktusConciergeSection: {
    width: '100%'
  },
  BrandInfo: {
    fontFamily: 'auto',
    fontSize: '20px',
    color: '#6C7B92'
  },
  didYouKnow: {
    fontSize: '28px',
    fontFamily: 'auto',
    fontWeight: 900,
    margin: 0,
    color: '#00A7E0'
  },
  isILocaBox: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 500,
    color: 'gray'
  },
  iBrandInfo: {
    fontFamily: 'auto',
    fontSize: '20px',
    color: '#6C7B92',
    fontWeight: 700
  },
  signInButton: {
    height: '55px',
    width: '45%',
    background: 'linear-gradient(135deg, #50A684 30%, #115E67 90%)',
    color: 'white'
  },
});

Amplify.configure({
  Auth: {
    region: process.env.REACT_APP_CG_REGION,
    userPoolId: process.env.REACT_APP_CG_USERPOOLID,
    userPoolWebClientId: process.env.REACT_APP_CG_WEBCLIENTID
  }
});

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      instruction: "Please login to continue",
      usernameError: false,
      passwordError: false,
      nameError: false,
      user: null,
      forgotPasswordFlow: false,
      forgotPasswordSMSFlow: false,
      userid: ''
    };
  }

  componentDidMount() {
    console.log(`App Verion: ${packageJson.version}`)
  }

  updateUsername = e => {
    this.setState({ username: e.target.value });
  };
  updateName = e => {
    this.setState({ name: e.target.value });
  };
  updateNewPassword = e => {
    this.setState({ newPassword: e.target.value });
  };
  updateSMSCode = e => {
    this.setState({ smsCode: e.target.value });
  };
  updateResetNewPassword = e => {
    this.setState({ resetNewPassword: e.target.value });
  };
  updateResetConfirmPassword = e => {
    this.setState({ resetConfirmPassword: e.target.value });
  };
  updateConfirmPassword = e => {
    this.setState({ confirmPassword: e.target.value });
  };
  updatePassword = e => {
    this.setState({ password: e.target.value });
  };
  signUp = e => {
    e.preventDefault();
    if (
      this.state.name &&
      this.state.newPassword &&
      this.state.confirmPassword &&
      this.state.newPassword === this.state.confirmPassword
    ) {
      Auth.completeNewPassword(this.state.user, this.state.newPassword, {
        name: this.state.name
      })
        .then(data => {
          this.setState({
            nameError: false,
            newPasswordError: false,
            confirmPasswordError: false
          });
          let userObj = {
            username: this.state.username
          };
          fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
            method: 'post',
            withCredentials: true,
            headers: {
              'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(userObj)
          })
            .then(response => {
              try {
                return response.text();
              } catch (error) {
                return null;
              }
            })
            .then(uData => {
              console.log(uData);
            });
          Auth.signIn(this.state.username, this.state.newPassword)
            .then(updatedUser => {
              this.setState({
                instruction: "Welcome!",
                usernameError: false,
                passwordError: false
              });
              sessionStorage.setItem("user", JSON.stringify(updatedUser));
              window.location.href = `/console`;
            })
            .catch(error => console.error(error));
        })
        .catch(error => {
          this.setState({
            instruction: error.message + "",
            newPasswordError: false,
            confirmPasswordError: false
          });
        });
    } else if (!this.state.name) {
      this.setState({ nameError: true });
    } else if (!this.state.newPassword) {
      this.setState({ newPasswordError: true });
    } else if (!this.state.confirmPassword) {
      this.setState({ confirmPasswordError: true });
    } else if (this.state.newPassword !== this.state.confirmPassword) {
      this.setState({
        instruction: "Passwords do not match.",
        nameError: false,
        newPasswordError: true,
        confirmPasswordError: true
      });
    }
  };
  forgotPassword = e => {
    if (!this.state.username) {
      this.setState({
        instruction:
          "Please provide your username and click Forgot Password button.",
        usernameError: true,
        passwordError: false
      });
    } else {
      Auth.forgotPassword(this.state.username)
        .then(data => {
          if (data.CodeDeliveryDetails.DeliveryMedium === "SMS") {
            const message = `A verification code is sent to your phone number ${data.CodeDeliveryDetails.Destination
              }`;
            this.setState({
              instruction: message,
              usernameError: false,
              passwordError: false,
              forgotPasswordSMSFlow: true
            });
          } else {
            const message =
              "An email has been sent to your email with a temporary password.";
            this.setState({
              instruction: message,
              usernameError: false,
              passwordError: false,
              forgotPasswordSMSFlow: true
            });
          }
          let userObj = {
            username: this.state.username
          };
          fetch(process.env.REACT_APP_BASEURL + 'getresetpwdatefromuser', {
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(userObj)
          })
            .then(response => {
              try {
                return response.text();
              } catch (error) {
                return null;
              }
            })
            .then(uData => {
              let Data = JSON.parse(uData)
              this.setState({ userid: Data[0].id })
            })
        })
        .catch(err =>
          this.setState({
            instruction: err.message,
            usernameError: false,
            passwordError: false
          })
        );
    }
  };
  forgotPasswordSubmit = e => {
    e.preventDefault();
    if (
      this.state.username &&
      this.state.smsCode &&
      this.state.resetNewPassword &&
      this.state.resetConfirmPassword &&
      this.state.resetNewPassword === this.state.resetConfirmPassword
    ) {
      let sha256 = require('js-sha256');
      let pw_hash = sha256(`${this.state.resetNewPassword} ${this.state.userid}`);
      fetch(process.env.REACT_APP_BASEURL + 'getLastPasswords/' + this.state.userid + "/" + pw_hash, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession
              .idToken.jwtToken,
          "Content-Type": "application/json"
        }
      }).then(response => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
        .then(passwordmatch => {
          let is_password_match = JSON.parse(passwordmatch)
          if (is_password_match.res === true || is_password_match.res === 'true') {
            this.setState({
              instruction: "Password already exists.",
              nameError: false,
              resetNewPasswordError: true,
              resetConfirmPasswordError: true
            });
          } else {
            Auth.forgotPasswordSubmit(
              this.state.username,
              this.state.smsCode,
              this.state.resetNewPassword
            )
              .then(data => {
                this.setState(
                  {
                    instruction: 'Password reset successful, Please login to continue.',
                    forgotPasswordSMSFlow: false
                  }
                );
                let pw_obj = {
                  userid: this.state.userid,
                  password: pw_hash
                }
                fetch(process.env.REACT_APP_BASEURL + 'savepassword', {
                  method: 'post',
                  headers: {
                    Authorization:
                      "Bearer " +
                      JSON.parse(sessionStorage.getItem("user")).signInUserSession
                        .idToken.jwtToken,
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(pw_obj)
                })
                  .then(response => {
                    try {
                      return response.text();
                    } catch (error) {
                      return null;
                    }
                  })
                  .then(uData => {
                    console.log(uData);
                  });
                let userObj = {
                  username: this.state.username
                };
                fetch(process.env.REACT_APP_BASEURL + 'UpdateResetPWDate', {
                  method: 'post',
                  withCredentials: true,
                  headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(userObj)
                })
                  .then(response => {
                    try {
                      return response.text();
                    } catch (error) {
                      return null;
                    }
                  })
                  .then(uData => {
                    console.log(uData);
                  });
              })
              .catch(err => console.error(err));
          }
        });
    } else if (!this.state.smsCode) {
      this.setState({ smsCodeError: true });
    } else if (!this.state.resetNewPassword) {
      this.setState({ resetNewPasswordError: true });
    } else if (!this.state.resetConfirmPassword) {
      this.setState({ resetConfirmPasswordError: true });
    } else if (this.state.resetNewPassword !== this.state.resetConfirmPassword) {
      this.setState({
        instruction: "Passwords do not match.",
        nameError: false,
        resetNewPasswordError: true,
        resetConfirmPasswordError: true
      });
    }
  };
  signIn = e => {
    if (this.state.forgotPasswordSMSFlow) {
    } else if (this.state.forgotPasswordFlow) {
    } else {
      e.preventDefault();
      let userObj = {
        username: this.state.username
      };
      fetch(process.env.REACT_APP_BASEURL + 'getresetpwdatefromuser', {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userObj)
      })
        .then(response => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then(uData => {
          let Data = JSON.parse(uData)
          this.setState({ userid: Data[0].id })
          let updatedDate = Data[0].password_reset_on;
          let lastupdatedDate = format(new Date(updatedDate), 'yyyy-MM-dd');
          let today = new Date();
          let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          let currentDate = format(new Date(date), 'yyyy-MM-dd');
          const timeDiff = (new Date(currentDate)) - (new Date(lastupdatedDate));
          const days = timeDiff / (1000 * 60 * 60 * 24)
          if (days >= 180) {
            Auth.forgotPassword(this.state.username)
              .then(data => {
                if (data.CodeDeliveryDetails.DeliveryMedium === "SMS") {
                  const message = `A verification code is sent to your phone number ${data.CodeDeliveryDetails.Destination
                    }`;
                  this.setState({
                    instruction: message,
                    usernameError: false,
                    passwordError: false,
                    forgotPasswordSMSFlow: true
                  });
                } else {
                  this.setState({
                    instruction:
                      "Your password has been expired please check your email for verification code and update your password.",
                    usernameError: false,
                    passwordError: false,
                    forgotPasswordSMSFlow: true
                  });
                }
              })
          } else {
            Auth.signIn(this.state.username, this.state.password)
              .then(user => {
                this.setState({
                  instruction: "Welcome!",
                  usernameError: false,
                  passwordError: false
                });
                if (
                  user.challengeName === "NEW_PASSWORD_REQUIRED" ||
                  user.challengeName === "PASSWORD_VERIFIER"
                ) {
                  this.setState({
                    instruction:
                      "Welcome! Please confirm your name and update your password.",
                    usernameError: false,
                    passwordError: false
                  });
                  this.setState({
                    user: user,
                    name: user.challengeParam.userAttributes.name
                  });
                } else {
                  sessionStorage.setItem("user", JSON.stringify(user));
                  let userObj = {
                    username: this.state.username
                  };
                  fetch(process.env.REACT_APP_BASEURL + 'UpdateLastLoginDateTime', {
                    method: 'post',
                    headers: {
                      Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession
                          .idToken.jwtToken,
                      "Content-Type": "application/json"
                    },
                    body: JSON.stringify(userObj)
                  })
                    .then(response => {
                      try {
                        return response.text();
                      } catch (error) {
                        return null;
                      }
                    })
                    .then(uData => {
                      const parsedUserObject = JSON.parse(uData);
                      const name = parsedUserObject && parsedUserObject.res && parsedUserObject.res.parentAccount && parsedUserObject.res.parentAccount.parentAccount && parsedUserObject.res.parentAccount.parentAccount.name;
                      if (name) {
                        sessionStorage.setItem('parentAccountName', JSON.parse(uData).res.parentAccount.parentAccount.name);
                      } else {
                        sessionStorage.setItem('parentAccountName', '');
                      }
                    });
                  //Get Permissions for Login user
                  fetch(process.env.REACT_APP_BASEURL + "getPermissions", {
                    method: "GET",
                    withCredentials: true,
                    headers: {
                      Authorization:
                        "Bearer " +
                        JSON.parse(sessionStorage.getItem("user")).signInUserSession
                          .idToken.jwtToken,
                      "Content-Type": "application/json"
                    }
                  })
                    .then(response => response.json())
                    .then(Permissons => {
                      if (Permissons.permission) {
                        // Added by manav
                        sessionStorage.setItem(
                          "permissions",
                          JSON.stringify(Permissons.permission)
                        );
                      }
                      if (Permissons.user) {
                        let roles;
                        if (Permissons.user.roles.length > 0) {
                          sessionStorage.setItem(
                            "permissionUser",
                            JSON.stringify(Permissons.user.roles[0].id)
                          );
                          roles = Permissons.user.roles;
                          roles.forEach(element => {
                            if (element.id === USER_ROLES.PHARMACIST) {
                              sessionStorage.setItem('roleId', JSON.stringify(element.id));
                            }
                            if (element.id === USER_ROLES.ADMIN) {
                              sessionStorage.setItem('admin', JSON.stringify(element.id));
                            }
                            if (element.id === USER_ROLES.SUPERADMIN) {
                              sessionStorage.setItem('superadmin', JSON.stringify(element.id));
                            }
                            if (element.id === USER_ROLES.DELIVERYTECH) {
                              sessionStorage.setItem('deliverytech', JSON.stringify(element.id))
                            }
                          });
                        }
                      }
                      window.location.href = `/console`;
                    });
                }
              }).catch(err => {
                switch (err.code) {
                  case "UserNotFoundException":
                    this.setState({ instruction: err.message, usernameError: true });
                    break;
                  case "NotAuthorizedException":
                  default:
                    this.setState({
                      instruction: "Invalid username or password.",
                      usernameError: true,
                      passwordError: true
                    });
                }
              });
          }
        })
    }
  };
  render() {
    const { classes } = this.props;
    var settings = {
      dots: true,
      infinite: true,
      autoplay: true,
      arrows: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    return (
      <div className={classes.root}>
        <Grid container style={{ height: '100%' }}>
          <Grid item xs={6}>
            <div className={classes.logoContainer}>
              <Logo />
            </div>
            <div className={classes.mainContentArea}>
              <Paper>
                <Grid container>
                  <Grid item sm={6} xs={12} className={classes.leftAdArea}>
                    <Hidden only={["xs"]}>
                      <p className={classes.leftAdAreaText}>
                        SIMPLE. SECURE. LOCAL.
                    </p>
                      <Slider
                        {...settings}
                        className={classes.sliderDivContainer}
                      >
                        <div className={classes.sliderDiv}>
                          <img
                            alt="1"
                            width={130}
                            src={slider1}
                            className={classes.chartIcon}
                          />
                        </div>
                        <div className={classes.sliderDiv}>
                          <img
                            alt="2"
                            width={130}
                            src={slider2}
                            className={classes.chartIcon}
                          />
                        </div>
                        <div className={classes.sliderDiv}>
                          <img
                            alt="3"
                            width={130}
                            src={slider3}
                            className={classes.chartIcon}
                          />
                        </div>
                      </Slider>
                    </Hidden>
                  </Grid>
                  <Grid item xs={12} sm={6} className={classes.loginArea}>
                    <div className={classes.loginContent}>
                      <form onSubmit={this.signIn}>
                        <img
                          className={classes.brandLogoSize2}
                          src={brandLogo}
                          alt="brand-logo"
                        />
                        <p className={classes.instruction}>
                          {this.state.instruction}
                        </p>
                         {!this.state.user && !this.state.forgotPasswordSMSFlow && (
                          <div>
                            <FormControl sx={{ m: 1, width: '31ch' }}>
                              <InputLabel htmlFor="username" style={{ marginLeft: '-1rem' }}>
                                Your Email
                            </InputLabel>
                              <Input
                                id="username"
                                type="text"
                                onChange={this.updateUsername}
                                tabIndex={1}
                                autoFocus
                                autoComplete="username"
                                error={this.state.usernameError}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disabled>
                                      <AccountCircle />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '31ch' }}>
                              <InputLabel htmlFor="password" style={{ marginLeft: '-1rem' }}>Password</InputLabel>
                              <Input
                                id="password"
                                type="password"
                                onChange={this.updatePassword}
                                tabIndex={2}
                                autoComplete="current-password"
                                error={this.state.passwordError}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disabled>
                                      <Lock />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <Stack
                              direction='row'
                              spacing={{ xs: 3, sm: 3, md: 2 }}
                              justifyContent={'center'}
                              className={classes.buttonBar}
                            >
                                    <NormalButton
                                      className={classes.ternaryButton}
                                      tabIndex={4}
                                      onClick={this.forgotPassword}
                                    >
                                      Forgot Password?
                                  </NormalButton>
                                    {this.state.user &&
                                      this.state.user.challengeName ===
                                      "NEW_PASSWORD_REQUIRED" && (
                                        <Button onClick={this.signUp} type="submit" variant={'contained'} className={classes.signInButton}>
                                          SIGN UP
                                        </Button>
                                       )}
                                    {!this.state.user && (
                                      <Button className={classes.signInButton} onClick={this.signIn} type="submit">
                                        SIGN IN
                                      </Button>
                                    )}
                                  </Stack>
                          </div>
                        )}
                          {this.state.forgotPasswordSMSFlow && (
                          <div>
                            <FormControl sx={{ m: 1, width: '31ch' }}>
                              <InputLabel htmlFor="smsCode" style={{ marginLeft: '-1rem' }}>
                                Verification Code
                            </InputLabel>
                              <Input
                                id="smsCode"
                                onChange={this.updateSMSCode}
                                tabIndex={2}
                                error={this.state.smsCodeError}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disabled>
                                      <Lock />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '31ch' }}>
                              <InputLabel htmlFor="password" style={{ marginLeft: '-1rem' }}>
                                New Password
                            </InputLabel>
                              <Input
                                id="password"
                                type="password"
                                onChange={this.updateResetNewPassword}
                                tabIndex={2}
                                autoComplete="current-password"
                                error={this.state.ResetNewPasswordError}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disabled>
                                      <Lock />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: '31ch' }}>
                              <InputLabel htmlFor="password" style={{ marginLeft: '-1rem' }}>
                                Confirm New Password
                            </InputLabel>
                              <Input
                                id="confirmPassword"
                                type="password"
                                onChange={this.updateResetConfirmPassword}
                                tabIndex={3}
                                autoComplete="confirm-password"
                                error={this.state.resetConfirmPasswordError}
                                endAdornment={
                                  <InputAdornment position="end">
                                    <IconButton disabled>
                                      <Lock />
                                    </IconButton>
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <Stack
                              direction='row'
                              spacing={{ xs: 2, sm: 2, md: 3 }}
                              justifyContent={'center'}
                              style={{ paddingBottom: '1rem', paddingTop: '1rem' }}
                            >
                              <Button
                               onClick={this.forgotPasswordSubmit}
                               className={classes.signInButton}
                               variant={'contained'}
                               type="submit"
                              >
                                  RESET PASSWORD
                              </Button>
                            </Stack>
                          </div>
                         )}
                        {this.state.user &&
                          this.state.user.challengeName ===
                          "NEW_PASSWORD_REQUIRED" && (
                            <div>
                              <FormControl sx={{ m: 1, width: '31ch' }}>
                                <InputLabel htmlFor="name" style={{ marginLeft: '-1rem' }}>Name</InputLabel>
                                <Input
                                  id="name"
                                  type="text"
                                  onChange={this.updateName}
                                  tabIndex={1}
                                  autoFocus
                                  autoComplete="name"
                                  error={this.state.nameError}
                                  defaultValue={this.state.name}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton disabled>
                                        <AccountCircle />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl sx={{ m: 1, width: '31ch' }}>
                                <InputLabel htmlFor="password" style={{ marginLeft: '-1rem' }}>
                                  New Password
                              </InputLabel>
                                <Input
                                  id="password"
                                  type="password"
                                  onChange={this.updateNewPassword}
                                  tabIndex={2}
                                  autoComplete="current-password"
                                  error={this.state.newPasswordError}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton disabled>
                                        <Lock />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <FormControl sx={{ m: 1, width: '31ch' }}>
                                <InputLabel htmlFor="password" style={{ marginLeft: '-1rem' }}>
                                  Confirm New Password
                              </InputLabel>
                                <Input
                                  id="confirmPassword"
                                  type="password"
                                  onChange={this.updateConfirmPassword}
                                  tabIndex={3}
                                  autoComplete="confirm-password"
                                  error={this.state.confirmPasswordError}
                                  endAdornment={
                                    <InputAdornment position="end">
                                      <IconButton disabled>
                                        <Lock />
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                              </FormControl>
                              <Stack
                              direction='row'
                              spacing={{ xs: 4, sm: 4, md: 3 }}
                              justifyContent={'center'}
                              className={classes.buttonBar}
                            >
                                  {this.state.user &&
                                    this.state.user.challengeName ===
                                    "NEW_PASSWORD_REQUIRED" && (
                                      <Button onClick={this.signUp} type="submit"
                                      className={classes.signInButton}
                                      >
                                        SIGN UP
                                      </Button>
                                    )}
                                  {!this.state.user && (
                                    <Button onClick={this.signIn} type="submit"
                                    className={classes.signInButton}
                                    >
                                      SIGN IN
                                    </Button>
                                  )}
                              </Stack>
                            </div>
                           )}
                      </form>
                    </div>
                  </Grid>
                </Grid>
              </Paper>
            </div>
            <div className={classes.footer}>
              <span>&copy; 2018 - {new Date().getFullYear()} <a target="new" style={{ color: '#115E67', textDecoration: 'none' }} href="https://ilocalbox.com/">ilocalbox.com</a>. All rights reserved.</span>
            </div>
          </Grid>
          <Grid item xs={6}>
            <div className={classes.rightmaincontent}>
              <div className={classes.sectionContainer}>
                <div className={classes.kaktusLogo}>
                  <img src={KaktusTopLogo} alt="Kaktus Logo" />
                </div>
                <div className={classes.LearnHowTo} style={{ marginTop: '1.5%' }}>
                  Learn how&nbsp;<span className={classes.hithLightedFont}>we are helping reshape patient care</span>&nbsp;with our suite of digital healthcare products and solutions.
                </div>
                <div className={classes.kaktusConcierge} style={{ marginTop: '3%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                    <img src={KaktusMobile} style={{ width: '10%' }} alt="Kaktus Mobile" />
                    <img src={KaktusConcierge} style={{ width: '10%' }} alt="Kaktus Concierge" />
                    <img src={KaktusDeliver} style={{ width: '10%' }} alt="Kaktus Deliver" />
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                    <label style={{ paddingLeft: '15px' }} className={classes.BrandInfo}>Kaktus Mobile</label>
                    <label style={{ marginRight: '-10px' }} className={classes.BrandInfo}>Kaktus Concierge</label>
                    <label className={classes.BrandInfo}>Kaktus Deliver</label>
                  </div>
                </div>
                <Paper style={{ marginTop: '3%', padding: '15px' }}>
                  <center>
                    <p className={classes.didYouKnow}>Did you know?</p>
                    <p className={classes.isILocaBox}>iLocalBox is powered by Kaktus?</p>
                    <div>
                      <img src={KaktusPoweredByGrey} style={{ width: '25%' }} alt="Kaktus Powered By" />
                    </div>
                  </center>
                  <div className={classes.kaktusConcierge}>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginTop: '-3%' }}>
                      <img src={IlocalCurbside} style={{ width: '15%' }} alt="Curbside" />
                      <img src={IlocalKiosk} style={{ width: '15%' }} alt="Kiosk" />
                      <img src={IlocalMail} style={{ width: '15%' }} alt="Mail Order" />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginTop: '-2%' }}>
                      <label className={classes.iBrandInfo}>&nbsp;&nbsp;&nbsp;Curbside</label>
                      <label className={classes.iBrandInfo} style={{marginLeft: '4%', marginRight: '4%'}}>&nbsp;Kiosk</label>
                      <label className={classes.iBrandInfo}>Mail Order</label>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
                      <img src={IlocalCounter} style={{ width: '15%' }} alt="Counter" />
                      <img src={IlocalCourier} style={{ width: '15%' }} alt="Courier" />
                      <img src={IlocalBedside} style={{ width: '15%' }} alt="Meds-to-Beds" />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', marginTop: '-2%' }}>
                      <label className={classes.iBrandInfo}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Counter</label>
                      <label className={classes.iBrandInfo} style={{marginLeft: '4%', marginRight: '4%'}}>&nbsp;&nbsp;&nbsp;&nbsp;Courier</label>
                      <label className={classes.iBrandInfo}>Meds-to-Beds</label>
                    </div>
                  </div>
                </Paper>
              </div>
              <div className={classes.kaktusBottom}>
                <img src={KaktusBottom} style={{ width: '100%' }} alt="Kaktus Bottom" />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}



export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/login/index.js